import { HbsmrRecordTypeResource } from "./HbsmrRecordTypeResource";
import { IResourceFactory, IRecordTypeResource, IMappingTextPack } from "@esdm/map";



export class HbsmrResourcefactory implements IResourceFactory {

    public constructor(
        private _mappingTextPack: IMappingTextPack
    ) {
    }

    public getRecordTypeResource(): IRecordTypeResource {
        return new HbsmrRecordTypeResource(this._mappingTextPack);
    }
}